import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  logoWrapper: {
    height: '46px',
    width: '100%',
  },
  logo: {
    width: 'max-content',
    marginRight: 'auto',
    marginLeft: '16px',
  },
  closeIconWrapper: {
    height: '100%',
    background: '#393F5C',
    borderRadius: '1px',
    marginLeft: '1rem',
    color: 'white',
  },
  closeIcon: {
    background: '#FFFFF',
  },
  timerAndAnsweredWrapper: {
    height: '40px',
    width: '100%',
    borderTop: `solid 1px ${theme?.palette?.headerDividerLines?.main}`,
  },
  timerWrapper: {
    width: '50%',
    borderRight: `solid 1px ${theme?.palette?.headerDividerLines?.main}`,
  },
  answeredWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  answeredText: {
    color: theme?.palette?.lightTextColor?.main,
  },
}))
export { useStyles }
